// extracted by mini-css-extract-plugin
export default {"title":"p87Yv8","benefits":"tZlkkd","benefit":"x_Xhco","icon":"e0tv6O"};